/* Prestige data layer (GTM ecommerce events). Moved out of snippets/data-layer.liquid so it is not parsed inline in <head>.
   All Liquid-dependent values come from window.ObDataLayerConfig (rendered by snippets/data-layer.liquid).
   See INP_NOTES.md. Logic, payloads and event order are the same as the inline version it replaces. */
(function() {
if (window.ObDataLayerLoaded) return;
window.ObDataLayerLoaded = true;
class Triangle_Digital_DataLayer {
  constructor(config) {
    this.config = config;
    window.dataLayer = window.dataLayer || [];
    // INP: pushes that may be deferred wait here (see pushJob / flushPending)
    this.pending = [];
    this.flushScheduled = false;
    // INP: one delegated document listener per event type (see delegate)
    this.delegates = {};

    // use a prefix of events name
    this.eventPrefix = '';

    //Keep the value false to get non-formatted product ID
    this.formattedItemId = true;

    // data schema
    this.dataSchema = {
      ecommerce: {
          show: true
      },
      dynamicRemarketing: {
          show: false,
          business_vertical: 'retail'
      }
    }

    // add to wishlist selectors
    this.addToWishListSelectors = {
      'addWishListIcon': '',
      'gridItemSelector': '',
      'productLinkSelector': 'a[href*="/products/"]'
    }

    // quick view selectors
    this.quickViewSelector = {
      'quickViewElement': '',
      'gridItemSelector': '',
      'productLinkSelector': 'a[href*="/products/"]'
    }

    // mini cart button selector
    this.miniCartButton = [
      'a[href="/cart"]',
    ];
    this.miniCartAppersOn = 'click';


    // begin checkout buttons/links selectors
    this.beginCheckoutButtons = [
      'input[name="checkout"]',
      'button[name="checkout"]',
      'a[href="/checkout"]',
      '.additional-checkout-buttons',
    ];

    // direct checkout button selector
    this.shopifyDirectCheckoutButton = [
      '.shopify-payment-button'
    ]

    //Keep the value true if Add to Cart redirects to the cart page
    this.isAddToCartRedirect = false;

    // keep the value false if cart items increment/decrement/remove refresh page
    this.isAjaxCartIncrementDecrement = true;


    // Caution: Do not modify anything below this line, as it may result in it not functioning correctly.
    this.cart = config.cart;
    this.countryCode = config.countryCode;
    this.storeURL = config.storeURL;
    localStorage.setItem('shopCountryCode', this.countryCode);
    // INP safety net: a deferred push is never lost when the tab is hidden or the page is left
    window.addEventListener('pagehide', () => this.flushPending());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') this.flushPending();
    });
    this.collectData();
    this.itemsList = [];
  }

  updateCart() {
    fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      this.cart = data;
    });
  }

 debounce(delay) {
    let timeoutId;
    return function(func) {
      const context = this;
      const args = arguments;

      clearTimeout(timeoutId);

      timeoutId = setTimeout(function() {
        func.apply(context, args);
      }, delay);
    };
  }

  eventConsole(eventName, eventData) {
    const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
    const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
    console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, eventData);
  }

  collectData() {
      this.customerData();
      this.ajaxRequestData();
      this.searchPageData();
      this.miniCartData();
      this.beginCheckoutData();

      if (this.config.template.cart) {
        this.viewCartPageData();
      }

      if (this.config.template.product) {
        this.productSinglePage();
      }

      if (this.config.template.collection) {
        this.collectionsPageData();
      }

      this.addToWishListData();
      this.quickViewData();
      this.selectItemData();
      this.formData();
      this.phoneClickData();
      this.emailClickData();
      this.loginRegisterData();
  }

  //logged-in customer data
  customerData() {
      const currentUser = {};
      // logged-in customer fields (id, names, email, phone, address) are rendered by Liquid into the config
      if (this.config.customer) {
        Object.assign(currentUser, this.config.customer);
      }

      if (currentUser.email) {
        currentUser.hash_email = this.config.hashEmail;
      }

      if (currentUser.phone) {
        currentUser.hash_phone = this.config.hashPhone;
      }

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        customer: currentUser
      });
  }

  // add_to_cart, remove_from_cart, search
  ajaxRequestData() {
    const self = this;

    // handle non-ajax add to cart
    if(this.isAddToCartRedirect) {
      this.delegate('submit', 'form[action="/cart/add"]', function(event) {
        const addToCartForm = event.target.closest('form[action="/cart/add"]');
        if(addToCartForm) {
          event.preventDefault();

          const formData = new FormData(addToCartForm);

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
              window.location.href = self.config.cartUrl;
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });
    }

    // fetch
    let originalFetch = window.fetch;
    let debounce = this.debounce(800);

    window.fetch = function () {
      return originalFetch.apply(this, arguments).then((response) => {
        if (response.ok) {
          let cloneResponse = response.clone();
          let requestURL = arguments[0]['url'] || arguments[0];

          if(typeof requestURL === 'string' && /.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {
            const queryString = requestURL.split('?')[1];
            const urlParams = new URLSearchParams(queryString);
            const search_term = urlParams.get("q");

            debounce(function() {
              fetch(`${self.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
                .then(res => res.json())
                .then(function(data) {
                      const products = data.resources.results.products;
                      if(products.length) {
                        const fetchRequests = products.map(product =>
                          fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                            .then(response => response.json())
                            .catch(error => console.error('Error fetching:', error))
                        );

                        Promise.all(fetchRequests)
                          .then(products => {
                              const items = products.map((product) => {
                                return {
                                  product_id: product.id,
                                  product_title: product.title,
                                  variant_id: product.variants[0].id,
                                  variant_title: product.variants[0].title,
                                  vendor: product.vendor,
                                  total_discount: 0,
                                  final_price: product.price_min,
                                  product_type: product.type,
                                  quantity: 1
                                }
                              });

                              self.ecommerceDataLayer('search', {search_term, items});
                          })
                      }else {
                        self.ecommerceDataLayer('search', {search_term, items: []});
                      }
                });
            });
          }
          else if (typeof requestURL === 'string' && requestURL.includes("/cart/add")) {
            cloneResponse.text().then((text) => {
              let data = JSON.parse(text);

              if(data.items && Array.isArray(data.items)) {
                data.items.forEach(function(item) {
                   self.ecommerceDataLayer('add_to_cart', {items: [item]});
                })
              } else {
                self.ecommerceDataLayer('add_to_cart', {items: [data]});
              }
              self.updateCart();
            });
          }else if(typeof requestURL === 'string' && requestURL.includes("/cart/change") || requestURL.includes("/cart/update")) {

             cloneResponse.text().then((text) => {

              let newCart = JSON.parse(text);
              let newCartItems = newCart.items;
              let oldCartItems = self.cart.items;

              for(let i = 0; i < oldCartItems.length; i++) {
                let item = oldCartItems[i];
                let newItem = newCartItems.find(newItems => newItems.id === item.id);


                if(newItem) {

                  if(newItem.quantity > item.quantity) {
                    // cart item increment
                    let quantity = (newItem.quantity - item.quantity);
                    let updatedItem = {...item, quantity}
                    self.ecommerceDataLayer('add_to_cart', {items: [updatedItem]});
                    self.updateCart();

                  }else if(newItem.quantity < item.quantity) {
                    // cart item decrement
                    let quantity = (item.quantity - newItem.quantity);
                    let updatedItem = {...item, quantity}
                    self.ecommerceDataLayer('remove_from_cart', {items: [updatedItem]});
                    self.updateCart();
                  }


                }else {
                  self.ecommerceDataLayer('remove_from_cart', {items: [item]});
                  self.updateCart();
                }
              }

            });
          }
        }
        return response;
      });
    }
    // end fetch


    //xhr
    var origXMLHttpRequest = XMLHttpRequest;
    XMLHttpRequest = function() {
      var requestURL;

      var xhr = new origXMLHttpRequest();
      var origOpen = xhr.open;
      var origSend = xhr.send;

      // Override the `open` function.
      xhr.open = function(method, url) {
          requestURL = url;
          return origOpen.apply(this, arguments);
      };


      xhr.send = function() {

          // Only proceed if the request URL matches what we're looking for.
          if (typeof requestURL === 'string' && (requestURL.includes("/cart/add") || requestURL.includes("/cart/change") || /.*\/search\/?.*\?.*q=.+/.test(requestURL))) {

              xhr.addEventListener('load', function() {
                  if (xhr.readyState === 4) {
                      if (xhr.status >= 200 && xhr.status < 400) {

                        if(typeof requestURL === 'string' && /.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {
                          const queryString = requestURL.split('?')[1];
                          const urlParams = new URLSearchParams(queryString);
                          const search_term = urlParams.get("q");

                          debounce(function() {
                              fetch(`${self.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
                                .then(res => res.json())
                                .then(function(data) {
                                      const products = data.resources.results.products;
                                      if(products.length) {
                                        const fetchRequests = products.map(product =>
                                          fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                                            .then(response => response.json())
                                            .catch(error => console.error('Error fetching:', error))
                                        );

                                        Promise.all(fetchRequests)
                                          .then(products => {
                                              const items = products.map((product) => {
                                                return {
                                                  product_id: product.id,
                                                  product_title: product.title,
                                                  variant_id: product.variants[0].id,
                                                  variant_title: product.variants[0].title,
                                                  vendor: product.vendor,
                                                  total_discount: 0,
                                                  final_price: product.price_min,
                                                  product_type: product.type,
                                                  quantity: 1
                                                }
                                              });

                                              self.ecommerceDataLayer('search', {search_term, items});
                                          })
                                      }else {
                                        self.ecommerceDataLayer('search', {search_term, items: []});
                                      }
                                });
                            });

                        }

                        else if(typeof requestURL === 'string' && requestURL.includes("/cart/add")) {
                            const data = JSON.parse(xhr.responseText);

                            if(data.items && Array.isArray(data.items)) {
                              data.items.forEach(function(item) {
                                  self.ecommerceDataLayer('add_to_cart', {items: [item]});
                                })
                            } else {
                              self.ecommerceDataLayer('add_to_cart', {items: [data]});
                            }
                            self.updateCart();

                         }else if(typeof requestURL === 'string' && requestURL.includes("/cart/change")) {

                            const newCart = JSON.parse(xhr.responseText);
                            const newCartItems = newCart.items;
                            let oldCartItems = self.cart.items;

                            for(let i = 0; i < oldCartItems.length; i++) {
                              let item = oldCartItems[i];
                              let newItem = newCartItems.find(newItems => newItems.id === item.id);


                              if(newItem) {
                                if(newItem.quantity > item.quantity) {
                                  // cart item increment
                                  let quantity = (newItem.quantity - item.quantity);
                                  let updatedItem = {...item, quantity}
                                  self.ecommerceDataLayer('add_to_cart', {items: [updatedItem]});
                                  self.updateCart();

                                }else if(newItem.quantity < item.quantity) {
                                  // cart item decrement
                                  let quantity = (item.quantity - newItem.quantity);
                                  let updatedItem = {...item, quantity}
                                  self.ecommerceDataLayer('remove_from_cart', {items: [updatedItem]});
                                  self.updateCart();
                                }


                              }else {
                                self.ecommerceDataLayer('remove_from_cart', {items: [item]});
                                self.updateCart();
                              }
                            }
                         }
                      }
                  }
              });
          }

          return origSend.apply(this, arguments);
      };

      return xhr;
    };
    //end xhr
  }

  // search event from search page
  searchPageData() {
    const self = this;
    let pageUrl = window.location.href;

    if(/.+\/search\?.*\&?q=.+/.test(pageUrl)) {
      const queryString = pageUrl.split('?')[1];
      const urlParams = new URLSearchParams(queryString);
      const search_term = urlParams.get("q");

      fetch(`${self.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
      .then(res => res.json())
      .then(function(data) {
            const products = data.resources.results.products;
            if(products.length) {
              const fetchRequests = products.map(product =>
                fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                  .then(response => response.json())
                  .catch(error => console.error('Error fetching:', error))
              );
              Promise.all(fetchRequests)
              .then(products => {
                  const items = products.map((product) => {
                      return {
                      product_id: product.id,
                      product_title: product.title,
                      variant_id: product.variants[0].id,
                      variant_title: product.variants[0].title,
                      vendor: product.vendor,
                      total_discount: 0,
                      final_price: product.price_min,
                      product_type: product.type,
                      quantity: 1
                      }
                  });

                  self.ecommerceDataLayer('search', {search_term, items});
              });
            }else {
              self.ecommerceDataLayer('search', {search_term, items: []});
            }
      });
    }
  }

  // view_cart
  miniCartData() {
    if(this.miniCartButton.length) {
      let self = this;
      if(this.miniCartAppersOn === 'hover') {
        this.miniCartAppersOn = 'mouseenter';
      }
      this.miniCartButton.forEach((selector) => {
        let miniCartButtons = document.querySelectorAll(selector);
        miniCartButtons.forEach((miniCartButton) => {
            miniCartButton.addEventListener(self.miniCartAppersOn, () => {
              self.ecommerceDataLayer('view_cart', self.cart);
            });
        })
      });
    }
  }

  // begin_checkout
  beginCheckoutData() {
    let self = this;
    // sync push on purpose: checkout navigates away
    this.delegate('pointerdown', self.beginCheckoutButtons.join(', '), (event) => {
      let targetElement = event.target.closest(self.beginCheckoutButtons.join(', '));
      if(targetElement) {
        self.ecommerceDataLayer('begin_checkout', self.cart);
      }
    });
  }

  // view_cart, add_to_cart, remove_from_cart
  viewCartPageData() {

    this.ecommerceDataLayer('view_cart', this.cart);

    //if cart quantity chagne reload page
    if(!this.isAjaxCartIncrementDecrement) {
      const self = this;
      this.delegate('pointerdown', 'a[href*="/cart/change?"]', (event) => {
        const target = event.target.closest('a[href*="/cart/change?"]');
        if(target) {
          const linkUrl = target.getAttribute('href');
          const queryString = linkUrl.split("?")[1];
          const urlParams = new URLSearchParams(queryString);
          const newQuantity = urlParams.get("quantity");
          const line = urlParams.get("line");
          const cart_id = urlParams.get("id");


          if(newQuantity && (line || cart_id)) {
            let item = line ? {...self.cart.items[line - 1]} : self.cart.items.find(item => item.key === cart_id);

            let event = 'add_to_cart';
            if(newQuantity < item.quantity) {
              event = 'remove_from_cart';
            }

            let quantity = Math.abs(newQuantity - item.quantity);
            item['quantity'] = quantity;

            self.ecommerceDataLayer(event, {items: [item]});
          }
        }
      });
    }
  }

  productSinglePage() {
    // product fields (item, variants) are rendered by Liquid into the config (product template only)
    const item = this.config.product.item;

    const variants = this.config.product.variants
    this.ecommerceDataLayer('view_item', {items: [item]});

    if(this.shopifyDirectCheckoutButton.length) {
        let self = this;
        // sync pushes on purpose: Buy now / dynamic checkout navigates away
        this.delegate('pointerdown', this.shopifyDirectCheckoutButton.join(', '), (event) => {
          let target = event.target;
          let checkoutButton = event.target.closest(this.shopifyDirectCheckoutButton.join(', '));

          if(checkoutButton && (variants || self.quickViewVariants)) {

              let checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
              if(checkoutForm) {

                  let variant_id = null;
                  let varientInput = checkoutForm.querySelector('input[name="id"]');
                  let varientIdFromURL = new URLSearchParams(window.location.search).get('variant');
                  let firstVarientId = item.variant_id;

                  if(varientInput) {
                    variant_id = parseInt(varientInput.value);
                  }else if(varientIdFromURL) {
                    variant_id = varientIdFromURL;
                  }else if(firstVarientId) {
                    variant_id = firstVarientId;
                  }

                  if(variant_id) {
                      variant_id = parseInt(variant_id);

                      let quantity = 1;
                      let quantitySelector = checkoutForm.getAttribute('id');
                      if(quantitySelector) {
                        let quentityInput = document.querySelector('input[name="quantity"][form="'+quantitySelector+'"]');
                        if(quentityInput) {
                            quantity = +quentityInput.value;
                        }
                      }

                      if(variant_id) {
                          let variant = variants.find(item => item.id === +variant_id);
                          if(variant && item) {
                              variant_id
                              item['variant_id'] = variant_id;
                              item['variant_title'] = variant.title;
                              item['final_price'] = variant.price;
                              item['quantity'] = quantity;

                              self.ecommerceDataLayer('add_to_cart', {items: [item]});
                              self.ecommerceDataLayer('begin_checkout', {items: [item]});
                          }else if(self.quickViewedItem) {
                            let variant = self.quickViewVariants.find(item => item.id === +variant_id);
                            if(variant) {
                              self.quickViewedItem['variant_id'] = variant_id;
                              self.quickViewedItem['variant_title'] = variant.title;
                              self.quickViewedItem['final_price'] = parseFloat(variant.price) * 100;
                              self.quickViewedItem['quantity'] = quantity;

                              self.ecommerceDataLayer('add_to_cart', {items: [self.quickViewedItem]});
                              self.ecommerceDataLayer('begin_checkout', {items: [self.quickViewedItem]});

                            }
                          }
                      }
                  }
              }

          }
        });
    }
  }

  collectionsPageData() {
    // collection items are rendered by Liquid into the config (collection template only)
    var ecommerce = {
      'items': this.config.collection.items
    };

    this.itemsList = ecommerce.items;
    ecommerce['item_list_id'] = this.config.collection.id
    ecommerce['item_list_name'] = this.config.collection.title

    this.ecommerceDataLayer('view_item_list', ecommerce);
  }


  // add to wishlist
  addToWishListData() {
    if(this.addToWishListSelectors && this.addToWishListSelectors.addWishListIcon) {
      const self = this;
      this.delegate('pointerdown', self.addToWishListSelectors.addWishListIcon, (event) => {
        let target = event.target;

        if(target.closest(self.addToWishListSelectors.addWishListIcon)) {
          let pageULR = window.location.href.replace(/\?.+/, '');
          let requestURL = undefined;

          if(/\/products\/[^/]+$/.test(pageULR)) {
            requestURL = pageULR;
          } else if(self.addToWishListSelectors.gridItemSelector && self.addToWishListSelectors.productLinkSelector) {
            let itemElement = target.closest(self.addToWishListSelectors.gridItemSelector);
            if(itemElement) {
              let linkElement = itemElement.querySelector(self.addToWishListSelectors.productLinkSelector);
              if(linkElement) {
                let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
                if(link && /\/products\/[^/]+$/.test(link)) {
                  requestURL = link;
                }
              }
            }
          }

          if(requestURL) {
            fetch(requestURL + '.json')
              .then(res => res.json())
              .then(result => {
                let data = result.product;
                if(data) {
                  let dataLayerData = {
                    product_id: data.id,
                      variant_id: data.variants[0].id,
                      product_title: data.title,
                    quantity: 1,
                    final_price: parseFloat(data.variants[0].price) * 100,
                    total_discount: 0,
                    product_type: data.product_type,
                    vendor: data.vendor,
                    variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                    sku: data.variants[0].sku,
                  }

                  self.ecommerceDataLayer('add_to_wishlist', {items: [dataLayerData]});
                }
              });
          }
        }
      });
    }
  }

  quickViewData() {
    if(this.quickViewSelector.quickViewElement && this.quickViewSelector.gridItemSelector && this.quickViewSelector.productLinkSelector) {
      const self = this;
      this.delegate('pointerdown', self.quickViewSelector.quickViewElement, (event) => {
        let target = event.target;
        if(target.closest(self.quickViewSelector.quickViewElement)) {
          let requestURL = undefined;
          let itemElement = target.closest(this.quickViewSelector.gridItemSelector );

          if(itemElement) {
            let linkElement = itemElement.querySelector(self.quickViewSelector.productLinkSelector);
            if(linkElement) {
              let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
              if(link && /\/products\/[^/]+$/.test(link)) {
                requestURL = link;
              }
            }
          }

          if(requestURL) {
              fetch(requestURL + '.json')
                .then(res => res.json())
                .then(result => {
                  let data = result.product;
                  if(data) {
                    let dataLayerData = {
                      product_id: data.id,
                      variant_id: data.variants[0].id,
                      product_title: data.title,
                      quantity: 1,
                      final_price: parseFloat(data.variants[0].price) * 100,
                      total_discount: 0,
                      product_type: data.product_type,
                      vendor: data.vendor,
                      variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                      sku: data.variants[0].sku,
                    }

                    self.ecommerceDataLayer('view_item', {items: [dataLayerData]});
                    self.quickViewVariants = data.variants;
                    self.quickViewedItem = dataLayerData;
                  }
                });
            }
        }
      });

      if(!this.config.template.product) {
        if(this.shopifyDirectCheckoutButton.length) {
          let self = this;
          this.delegate('pointerdown', this.shopifyDirectCheckoutButton.join(', '), (event) => {
            let target = event.target;
            let checkoutButton = event.target.closest(this.shopifyDirectCheckoutButton.join(', '));

            if(self.quickViewVariants && self.quickViewedItem && self.quickViewVariants.length && checkoutButton) {

              let checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
              if(checkoutForm) {
                  let quantity = 1;
                  let varientInput = checkoutForm.querySelector('input[name="id"]');
                  let quantitySelector = checkoutForm.getAttribute('id');

                  if(quantitySelector) {
                    let quentityInput = document.querySelector('input[name="quantity"][form="'+quantitySelector+'"]');
                    if(quentityInput) {
                        quantity = +quentityInput.value;
                    }
                  }

                  if(varientInput) {
                      let variant_id = parseInt(varientInput.value);

                      if(variant_id) {
                          const variant = self.quickViewVariants.find(item => item.id === +variant_id);
                          if(variant && self.quickViewedItem) {
                              self.quickViewedItem['variant_id'] = variant_id;
                              self.quickViewedItem['variant_title'] = variant.title;
                              self.quickViewedItem['final_price'] = parseFloat(variant.price) * 100;
                              self.quickViewedItem['quantity'] = quantity;

                              self.ecommerceDataLayer('add_to_cart', {items: [self.quickViewedItem]});
                              self.ecommerceDataLayer('begin_checkout', {items: [self.quickViewedItem]});
                          }
                      }
                  }
              }

            }
          });
      }
      }
    }
  }

  // select_item events
  selectItemData() {

    const self = this;
    const items = this.itemsList;

    if(this.config.template.collection) {
      // sync push on purpose: the tap is a link that navigates to the product page
      this.delegate('pointerdown', 'a[href*="/products/"]', function(event) {

        const productLink = event.target.closest('a[href*="/products/"]');

        if(productLink) {
            const linkUrl = productLink.getAttribute('href');

            const matchProduct = (item) => {
              var itemSlug = (item.url.split('/products/')[1]).split('#')[0].split('?')[0].trim();
              var linkUrlItemSlug = (linkUrl.split('/products/')[1]).split('#')[0].split('?')[0].trim();

              return itemSlug === linkUrlItemSlug;
            }

            const item = items.find(matchProduct);
            const index = items.findIndex(matchProduct);

            if(item) {
              self.ecommerceDataLayer('select_item', {items: [{...item, index: index}]});
            }
        }
      });
    }

    // select item on varient change
    // The theme's variant:change event only carries {formId, variant, previousVariant}, so product fields come from Liquid (config).
    if(this.config.template.product) {
    const pageProduct = this.config.product;
    const pageVariantIds = pageProduct.variants.map(function(v) { return v.id; });
    document.addEventListener('variant:change', function(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id || !pageVariantIds.includes(variant.id)) return;

       const item = {
          product_id: pageProduct.id,
          product_title: pageProduct.title,
          variant_id: variant.id,
          variant_title: variant.public_title,
          vendor: pageProduct.vendor,
          final_price: variant.price,
          product_type: pageProduct.type,
          quantity: 1
       }

       // deferred push (INP): a variant tap does not navigate; the payload is built now, only the dataLayer.push waits one frame
       self.ecommerceDataLayer('select_item', {items: [item]}, true);
    });
    }
  }

  // all ecommerce events
  // deferPush=true (only select_item on variant change): the payload is still built right now, only the dataLayer.push waits.
  ecommerceDataLayer(event, data, deferPush) {
    const self = this;
    // pushes of this event, in the original order: ecommerce clear, [dynamicRemarketing clear], event
    const pushes = [{ 'ecommerce': null }];
    let dataLayerData;
    try {
    dataLayerData = {
      "event": this.eventPrefix + event,
      'ecommerce': {
         'currency': this.cart.currency,
         'items': data.items.map((item, index) => {
           const dataLayerItem = {
              'index': index,
              'item_id': this.formattedItemId  ? `shopify_${this.countryCode}_${item.product_id}_${item.variant_id}` : item.product_id.toString(),
              'product_id': item.product_id.toString(),
              'variant_id': item.variant_id.toString(),
              'item_name': item.product_title,
              'quantity': item.quantity,
              'price': +((item.final_price / 100).toFixed(2)),
              'discount': item.total_discount ? +((item.total_discount / 100).toFixed(2)) : 0
          }

          if(item.product_type) {
            dataLayerItem['item_category'] = item.product_type;
          }

          if(item.vendor) {
            dataLayerItem['item_brand'] = item.vendor;
          }

          if(item.variant_title && item.variant_title !== 'Default Title') {
            dataLayerItem['item_variant'] = item.variant_title;
          }

          if(item.sku) {
            dataLayerItem['sku'] = item.sku;
          }

          if(item.item_list_name) {
            dataLayerItem['item_list_name'] = item.item_list_name;
          }

          if(item.item_list_id) {
            dataLayerItem['item_list_id'] = item.item_list_id.toString()
          }

          return dataLayerItem;
        })
      }
    }

    if(data.total_price !== undefined) {
      dataLayerData['ecommerce']['value'] =  +((data.total_price / 100).toFixed(2));
    } else {
      dataLayerData['ecommerce']['value'] = +(dataLayerData['ecommerce']['items'].reduce((total, item) => total + (item.price * item.quantity), 0)).toFixed(2);
    }

    if(data.item_list_id) {
      dataLayerData['ecommerce']['item_list_id'] = data.item_list_id;
    }

    if(data.item_list_name) {
      dataLayerData['ecommerce']['item_list_name'] = data.item_list_name;
    }

    if(data.search_term) {
      dataLayerData['search_term'] = data.search_term;
    }

    if(self.dataSchema.dynamicRemarketing && self.dataSchema.dynamicRemarketing.show) {
      pushes.push({ 'dynamicRemarketing': null });
      dataLayerData['dynamicRemarketing'] = {
          value: dataLayerData.ecommerce.value,
          items: dataLayerData.ecommerce.items.map(item => ({id: item.item_id, google_business_vertical: self.dataSchema.dynamicRemarketing.business_vertical}))
      }
    }

    if(!self.dataSchema.ecommerce ||  !self.dataSchema.ecommerce.show) {
      delete dataLayerData['ecommerce'];
    }

    pushes.push(dataLayerData);
    } finally {
      // same as before when the build throws: the ecommerce clear was already pushed, the event was not
      this.pushJob(function() {
        pushes.forEach(function(obj) { dataLayer.push(obj); });
        if (pushes.length > 1 && pushes[pushes.length - 1] === dataLayerData) {
          self.eventConsole(self.eventPrefix + event, dataLayerData);
        }
      }, deferPush);
    }
  }

  // INP: run a dataLayer push job. Sync (default): anything still queued goes first so the order never changes, then the job runs now.
  // Deferred: the job waits for the next frame (rAF + timeout, with a fallback timer); it is also flushed when the page is hidden/unloaded.
  pushJob(job, deferPush) {
    if (!deferPush) {
      this.flushPending();
      job();
      return;
    }
    this.pending.push(job);
    this.scheduleFlush();
  }

  scheduleFlush() {
    if (this.flushScheduled) return;
    this.flushScheduled = true;
    const run = () => this.flushPending();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => setTimeout(run, 0));
    }
    setTimeout(run, 150);
  }

  flushPending() {
    this.flushScheduled = false;
    while (this.pending.length) {
      const job = this.pending.shift();
      try { job(); } catch (error) { setTimeout(function() { throw error; }); }
    }
  }

  // sync dataLayer.push for events that are not ecommerce events
  pushNow(obj) {
    this.flushPending();
    dataLayer.push(obj);
  }

  // INP: one delegated document listener per event type. Handlers run in registration order, each with its own checks,
  // exactly like the separate document listeners they replace. The combined selector is only a cheap early exit.
  delegate(type, selector, handler) {
    let d = this.delegates[type];
    if (!d) {
      d = this.delegates[type] = { list: [], selectors: [], combined: '' };
      document.addEventListener(type, (event) => this.dispatch(type, event));
    }
    d.list.push(handler);
    if (selector) d.selectors.push(selector);
    d.combined = d.selectors.join(', ');
    // a handler without a selector can never be skipped
    if (!selector) d.always = true;
  }

  dispatch(type, event) {
    const d = this.delegates[type];
    if (!d.always) {
      const t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      try { if (!t.closest(d.combined)) return; } catch (error) { /* bad selector: run every handler */ }
    }
    for (let i = 0; i < d.list.length; i++) {
      try { d.list[i](event); } catch (error) { setTimeout(function() { throw error; }); }
    }
  }


  // contact form submit & newsletters signup
  formData() {
    const self = this;
    // sync pushes on purpose: a contact / newsletter post navigates away
    this.delegate('submit', 'form[action^="/contact"]', function(event) {

      let targetForm = event.target.closest('form[action^="/contact"]');


      if(targetForm) {
        const formData = {
          form_location: window.location.href,
          form_id: targetForm.getAttribute('id'),
          form_classes: targetForm.getAttribute('class')
        };

        let formType = targetForm.querySelector('input[name="form_type"]');
        let inputs = targetForm.querySelectorAll("input:not([type=hidden]):not([type=submit]), textarea, select");

        inputs.forEach(function(input) {
          var inputName = input.name;
          var inputValue = input.value;

          if (inputName && inputValue) {
            var matches = inputName.match(/\[(.*?)\]/);
            if (matches && matches.length > 1) {
               var fieldName = matches[1];
               formData[fieldName] = input.value;
            }
          }
        });

        if(formType && formType.value === 'customer') {
          self.pushNow({ event: self.eventPrefix + 'newsletter_signup', ...formData});
          self.eventConsole(self.eventPrefix + 'newsletter_signup', { event: self.eventPrefix + 'newsletter_signup', ...formData});

        } else if(formType && formType.value === 'contact') {
          self.pushNow({ event: self.eventPrefix + 'contact_form_submit', ...formData});
          self.eventConsole(self.eventPrefix + 'contact_form_submit', { event: self.eventPrefix + 'contact_form_submit', ...formData});
        }
      }
    });

  }

  // phone_number_click event
  phoneClickData() {
    const self = this;
    this.delegate('click', 'a[href^="tel:"]', function(event) {
      let target = event.target.closest('a[href^="tel:"]');
      if(target) {
        let phone_number = target.getAttribute('href').replace('tel:', '');
        let eventData = {
          event: self.eventPrefix + 'phone_number_click',
          page_location: window.location.href,
          link_classes: target.getAttribute('class'),
          link_id: target.getAttribute('id'),
          phone_number
        }

        self.pushNow(eventData);
        self.eventConsole(self.eventPrefix + 'phone_number_click', eventData);
      }
    });
  }

  // email_click event
  emailClickData() {
    const self = this;
    this.delegate('click', 'a[href^="mailto:"]', function(event) {
      let target = event.target.closest('a[href^="mailto:"]');
      if(target) {
        let email_address = target.getAttribute('href').replace('mailto:', '');
        let eventData = {
          event: self.eventPrefix + 'email_click',
          page_location: window.location.href,
          link_classes: target.getAttribute('class'),
          link_id: target.getAttribute('id'),
          email_address
        }

        self.pushNow(eventData);
        self.eventConsole(self.eventPrefix + 'email_click', eventData);
      }
    });
  }

  //login register
  loginRegisterData() {

    const self = this;
    let isTrackedLogin = false;
    let isTrackedRegister = false;

    if(window.location.href.includes('/account/login')) {
      this.delegate('submit', '[action="/account/login"]', function(e) {
        const loginForm = e.target.closest('[action="/account/login"]');
        if(loginForm && !isTrackedLogin) {
            const eventData = {
              event: self.eventPrefix + 'login'
            }
            isTrackedLogin = true;
            self.pushNow(eventData);
            self.eventConsole(self.eventPrefix + 'login', eventData);
        }
      });
    }

    if(window.location.href.includes('/account/register')) {
      this.delegate('submit', '[action="/account"]', function(e) {
        const registerForm = e.target.closest('[action="/account"]');
        if(registerForm && !isTrackedRegister) {
            const eventData = {
              event: self.eventPrefix + 'sign_up'
            }

            isTrackedRegister = true;
            self.pushNow(eventData);
            self.eventConsole(self.eventPrefix + 'sign_up', eventData);
        }
      });
    }
  }
}
// end Triangle_Digital_DataLayer

// Start exactly where the inline version started: on DOMContentLoaded. The inline stub in snippets/data-layer.liquid registers that
// listener in <head> (same position as before) and sets window.ObDataLayerDom; deferred scripts run before DOMContentLoaded, so
// ObDataLayerStart already exists when the stub's listener fires. If this file ever loads after DOMContentLoaded it starts at once.
var started = false;
function start() {
  if (started) return;
  started = true;
  try {
    new Triangle_Digital_DataLayer(window.ObDataLayerConfig);
  } catch(error) {
    console.log(error);
  }
}
window.ObDataLayerStart = start;
if (window.ObDataLayerDom || document.readyState === 'complete') {
  start();
}
})();
